<template>
  <div class="feed">
    <PostCard
      v-for="post in posts"
      :key="post.id"
      :new-post="!post.seenBy.includes(participantId)"
      :post="post"
      :participants="participants"
      :owner="owner"
      :participant-id="participantId"
      @show-post-details-modal="$emit('show-post-details-modal', $event)"
    />
    <EmptyFeed v-if="isEmpty" :context="Context.DsrPublished" />
    <LoadMore v-else :loading="loadingPosts" @load="feedStore.load">
      <PostSkeleton />
    </LoadMore>
  </div>
</template>
<script lang="ts">
import type { PropType } from 'vue';
import { defineComponent, computed } from 'vue';
import type { Participant } from '@getaccept/dsr-shared-new';
import { storeToRefs } from 'pinia';
import LoadMore from '@getaccept/dsr-shared-new/src/components/LoadMore.vue';
import { useI18n } from 'vue-i18n';
import EmptyFeed from '@getaccept/dsr-shared-new/src/components/EmptyFeed.vue';
import PostSkeleton from '@getaccept/dsr-shared-new/src/feed/components/PostSkeleton.vue';
import { Context } from '@getaccept/editor-lib-new';
import { usePublishedFeedStore } from '../store/feed.store';
import PostCard from './Post.vue';

export default defineComponent({
  components: {
    PostCard,
    LoadMore,
    EmptyFeed,
    PostSkeleton,
  },
  props: {
    participants: {
      type: Array as PropType<Participant[]>,
      default: () => [],
    },
    owner: {
      type: Object as PropType<Participant>,
      default: () => ({} as Participant),
    },
    participantId: {
      type: String,
      required: true,
    },
  },
  setup() {
    const { t } = useI18n();
    const feedStore = usePublishedFeedStore();
    const { posts, loadingPosts } = storeToRefs(feedStore);

    const isEmpty = computed(() => !posts.value.length && !loadingPosts.value);

    return {
      loadingPosts,
      posts,
      feedStore,
      isEmpty,
      t,
      Context,
    };
  },
});
</script>
